import * as React from "react"
import type { SVGProps } from "react"

export const PlayDisabledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M15.854 13.388 14.8 12.304l.346-.212-2.537-1.948-3.788-3.788a.96.96 0 0 1 .513-.214.83.83 0 0 1 .562.148l6.98 4.937q.427.27.415.768a.89.89 0 0 1-.44.768zm2.33 7.3-5.338-5.369-2.95 1.898a.83.83 0 0 1-.924.033.86.86 0 0 1-.472-.806v-5.471L3.292 5.765a.73.73 0 0 1-.212-.522.7.7 0 0 1 .212-.531.72.72 0 0 1 .527-.218q.31 0 .527.218l14.908 14.907a.74.74 0 0 1 0 1.07.8.8 0 0 1-.535.224.7.7 0 0 1-.535-.225M10 15.35l1.742-1.116L10 12.492z"
    ></path>
  </svg>
)
